import { Injectable } from '@angular/core';
import { ExecutedPaymentBatch } from '../models';
import { PaymentResultsDialogComponent, PaymentResultsDialogData } from '../components';
// TODO: This creeps towards a circular dependency. We should refactor the code to avoid this.
import {
  PaymentResultUnknownDialogComponent,
  PaymentResultUnknownDialogData,
} from '../../../components/main/modals/payment-unknown/payment-unknown.component';
import { PaymentsState } from '../state';
import { ConfigState } from '@aiwyn/config';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { isLoaded, isLoading } from '@aiwyn/shared';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

type PaymentResultsDialogRef = MatDialogRef<PaymentResultsDialogComponent, PaymentResultsDialogData>
  | MatDialogRef<PaymentResultUnknownDialogComponent, PaymentResultUnknownDialogData>;

@Injectable({
  providedIn: 'root',
})
export class PaymentsSharedService {
  constructor(
    private readonly spinner: NgxSpinnerService,
    private readonly dialog: MatDialog,
    private readonly store: Store,
    private readonly paymentsState: PaymentsState,
  ) {}

  getPaymentResultsDialogRef(payments: ExecutedPaymentBatch, primaryEmail: string, isQuickPayment: boolean): PaymentResultsDialogRef {
    const paymentsArray = [payments.initial].concat('addOns' in payments ? payments.addOns : []);
    const somePaymentHasZeroStatusError = paymentsArray.some(({ error }) => error?.status === 0);
    if (!somePaymentHasZeroStatusError) {
      return this.dialog.open<PaymentResultsDialogComponent, PaymentResultsDialogData>(
        PaymentResultsDialogComponent,
        { data: { payments, primaryEmail, isQuickPayment } },
      );
    }

    const initialPayloadTotal = 'chargeDetails' in payments.initial.data
      ? payments.initial.data.chargeDetails.paymentDetails.amount
      : payments.initial.data.allocations.reduce((total, { allocated }) => total - allocated, 0);
    const addOnsTotal = 'addOns' in payments
      ? payments.addOns.reduce((addOnsTotal, addOn) => addOnsTotal + addOn.data.chargeDetails.paymentDetails.amount, 0)
      : 0;
    const total = initialPayloadTotal + addOnsTotal;

    return this.dialog.open<PaymentResultUnknownDialogComponent, PaymentResultUnknownDialogData>(
      PaymentResultUnknownDialogComponent,
      {
        width: '600px',
        data: {
          amount: total,
          invoiceIds: this.store.selectSnapshot(PaymentsState.getSelectedPayableIds),
          primaryEmailRecipient: this.paymentsState.getPrimaryRecipientEmailSnapshot(),
          firmName: this.store.selectSnapshot(ConfigState.getCustomerName),
        },
      },
    );
  }

  onPaymentCompletion(isQuickPayment: boolean = false): Observable<unknown> {
    const payments = this.store.selectSnapshot(PaymentsState.getLastExecutedPaymentBatch);
    const primaryEmail = this.paymentsState.getPrimaryRecipientEmailSnapshot();

    // get payment results
    return (this.getPaymentResultsDialogRef(payments, primaryEmail, isQuickPayment).afterClosed() as Observable<unknown>).pipe(
      switchMap(_ => this.store.selectOnce(PaymentsState.getPayablesStatus)),
      isLoading(),
      tap(_ => this.spinner.show()),
      switchMap(_ => isQuickPayment ? of(true) : this.store.select(PaymentsState.getPayablesStatus).pipe(isLoaded(true))),
      take(1),
      tap(_ => this.spinner.hide()),
    );
  }
}
